// アップロードなどの失敗を、画面に出せる形にする。
// 以前は、失敗の理由に関係なく「画像は〇MB以下」という文言を出していたため、画像が小さくても
// サイズの問題に見えていた。実際の理由（HTTPの状態、サーバーのメッセージ、通信エラー）を出す。

export interface ApiErrorDetail {
  /** HTTPの状態。応答が得られなかったときは undefined */
  status?: number;
  /** サーバーが返した error の文言 */
  serverMessage?: string;
  /** サーバーに届かなかった（通信できなかった） */
  network: boolean;
  /** 画面に添える短い説明。例: 400: 画像ファイルを選択してください */
  text: string;
}

const NETWORK_ERROR = /network request failed|failed to fetch|load failed|network error|timed out|timeout/i;

export function describeApiError(error: unknown): ApiErrorDetail {
  const message = error instanceof Error ? error.message : typeof error === "string" ? error : "";

  if (/401_UNAUTHORIZED/.test(message)) {
    return { status: 401, network: false, text: "401: ログインの有効期限が切れました" };
  }

  // shared/api/apiFetchCore.ts が作るメッセージ: "API error: 400 {"error":"..."}"
  const match = message.match(/^API error: (\d{3})\s*([\s\S]*)$/);
  if (match) {
    const status = Number(match[1]);
    let serverMessage: string | undefined;
    try {
      const parsed = JSON.parse(match[2]);
      if (typeof parsed?.error === "string") serverMessage = parsed.error;
    } catch {
      // JSONでない本文（プロキシのエラーページなど）は、先頭だけ使う。
      serverMessage = match[2].replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim().slice(0, 80) || undefined;
    }
    return { status, serverMessage, network: false, text: serverMessage ? `${status}: ${serverMessage}` : String(status) };
  }

  if (NETWORK_ERROR.test(message)) {
    return { network: true, text: "通信できませんでした" };
  }
  return { network: false, text: message.slice(0, 80) || "原因不明のエラー" };
}
